import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RelatedEventList from "./RelatedEventList";
import ExhibitionSlider from "../ExhibitionSlider";
import { exhibitionsApiRequest } from "../../../api";
import Placeholder from "../Teaser/Placeholder";

function Current({ query, heading, openCloseMessage, id, onFetch }) {
  const defaultExhibitions = [];
  const [active, setActive] = useState(0);
  const [exhibitions, setExhibitions] = useState(defaultExhibitions);
  const [isLoading, setIsLoading] = useState(false);

  // `defaultExhibitions` shouldn't be a dependency of this effect
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    function onSuccess(response) {
      const hasExhibitions = response.records && response.records.length > 0;
      setExhibitions(hasExhibitions ? response.records : defaultExhibitions);
      setIsLoading(false);
      onFetch("current", "all", hasExhibitions);
    }

    const fetchData = () => {
      setIsLoading(true);
      exhibitionsApiRequest({ current: true, all: true, ...query }, onSuccess);
    };

    fetchData();
  }, [query]);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (exhibitions.length <= 0) return null;

  return (
    <header
      className="m-exhibition-header m-exhibition-header--landing a-bg-cream"
      id={id}
    >
      <div className="m-exhibition-header__inner">
        <div className="m-exhibition-header__nav-block">
          <h2>{heading}</h2>
          {openCloseMessage && (
            <div className="m-exhibition-header__open-close m-current-hours">
              {openCloseMessage}
            </div>
          )}
        </div>
        <div className="m-exhibition-header__wide-block">
          {isLoading && <Placeholder />}
          <ExhibitionSlider
            exhibitions={exhibitions}
            active={active}
            onUpdate={setActive}
          />
        </div>
        <div className="m-exhibition-header__narrow-block">
          <RelatedEventList exhibition={exhibitions[active]} />
        </div>
      </div>
    </header>
  );
}

Current.displayName = "ExhibitionsLanding.Current";

Current.propTypes = {
  query: PropTypes.object,
  heading: PropTypes.string.isRequired,
  openCloseMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  onFetch: PropTypes.func,
};

export default Current;
